import { IAnyObject } from "../../interfaces";

export enum ExceptionType {
	Connection = "ConnectionError",
	NoAuth = "NoAuthError",
	Cancel = "CancelError",
	Server = "ServerError",
	UrlOpen = "UrlOpenError",
	BadParams = "BadParamsError",
	AuthFailed = "AuthFailedError",
	NoPermission = "NoPermission",
	UnknownError = "UnknownError",
}

export abstract class ApiError extends Error {
	public type: ExceptionType;
	public data?: string | null | IAnyObject;
}

export class NoAuthError extends ApiError {
	readonly type = ExceptionType.NoAuth;
}

export class ServerError extends ApiError {
	constructor(data: string | null | IAnyObject, message?: string) {
		super(message);
		this.type = ExceptionType.Server;
		this.data = data;
	}
}
